import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MarkdownModule } from 'ngx-markdown';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChatComponent } from './chat.component';
import { ChatAudioComponent } from './components/audio-level/audio-level.component';
import { ChatWidgetComponent } from './components/chat-widget/chat-widget.component';
import { ConfigurationService } from './services/configuration.service';
import { ChatSupportLinkComponent } from './components/chat-support-link/chat-support-link.component';
import { ChatFeedbackComponent } from './components/chat-feedback/chat-feedback.component';
import { ChatInputComponent } from './components/chat-input/chat-input.component';
import { ChatFormInputComponent } from './components/chat-form-input/chat-form-input.component';
import { MentionModule } from './components/chat-mention';
import { ChatToggleComponent } from './components/chat-toggle/chat-toggle.component';
import { ChatCameraDialogComponent } from './components/chat-camera-dialog/chat-camera-dialog.component';
import { SubscriptionRestrictionComponent } from './components/subscription-restriction/subscription-restriction.component';
import { ChatOptionsMenuComponent } from './components/chat-options-menu/chat-options-menu.component';
import { ChatSelectModalComponent } from './components/chat-select-modal/chat-select-modal.component';
import { ChatAutocompleteModalComponent } from './components/chat-autocomplete-modal/chat-autocomplete-modal.component';
import { AppGenerativeWidgetComponent } from './components/app-generative-widget/app-generative-widget.component';
import { GenerativeWidgetCommandLayoutComponent } from './components/generative-widget-command-layout/generative-widget-command-layout.component';
import { PlotlyViaCDNModule } from 'angular-plotly.js';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { QuickSelectOptionsComponent } from './components/quick-select-options/quick-select-options.component';
import { ChatSupportTickets } from './components/chat-support-tickets/chat-support-tickets.component'
import { ChatImageMessageComponent } from './components/chat-image-message/chat-image-message.component';
import { FilePreviewPopupComponent } from './components/file-preview-popup/file-preview-popup.component';
import { ChatResourceCardsComponent } from './components/chat-resource-cards/chat-resource-cards.component';
import { AiQuoteChatComponent } from './components/ai-quote/ai-quote-chat/ai-quote-chat.component';
import { AiQuoteChatInputComponent } from './components/ai-quote/ai-quote-chat-input/ai-quote-chat-input.component';
import { CustomTooltipDirective } from './directives/tooltip.directive';
import { ChatMarkdownComponent } from './components/chat-markdown/chat-markdown.component';
import { AiQuoteFormComponent } from './components/ai-quote/ai-quote-form/ai-quote-form.component';
import { AiQuoteSimpleFormComponent } from './components/ai-quote/ai-quote-simple-form/ai-quote-simple-form.component';

PlotlyViaCDNModule.setPlotlyVersion('latest');
PlotlyViaCDNModule.setPlotlyBundle('basic');

@NgModule({
    declarations: [
        ChatComponent,
        AppGenerativeWidgetComponent,
        AiQuoteChatComponent,
        AiQuoteChatInputComponent,
        AiQuoteFormComponent,
        AiQuoteSimpleFormComponent,
        ChatInputComponent,
        ChatToggleComponent,
        ChatWidgetComponent,
        ChatFormInputComponent,
        ChatSupportLinkComponent,
        ChatFeedbackComponent,
        ChatAudioComponent,
        ChatCameraDialogComponent,
        SubscriptionRestrictionComponent,
        ChatOptionsMenuComponent,
        QuickSelectOptionsComponent,
        ChatSelectModalComponent,
        ChatAutocompleteModalComponent,
        ChatResourceCardsComponent,
        GenerativeWidgetCommandLayoutComponent,
        SafeHtmlPipe,
        ChatSupportTickets,
        ChatImageMessageComponent,
        FilePreviewPopupComponent
    ],
    imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MarkdownModule,
    ChatMarkdownComponent,
    PlotlyViaCDNModule,
    MentionModule,
    MatTooltipModule,
    CustomTooltipDirective,
],
    exports: [
        ChatComponent,
        AppGenerativeWidgetComponent,
        AiQuoteChatComponent,
        AiQuoteChatInputComponent,
        AiQuoteFormComponent,
        AiQuoteSimpleFormComponent,
        ChatInputComponent,
        ChatToggleComponent,
        ChatWidgetComponent,
        ChatFormInputComponent,
        ChatSupportLinkComponent,
        ChatFeedbackComponent,
        ChatAudioComponent,
        SubscriptionRestrictionComponent,
        ChatOptionsMenuComponent,
        QuickSelectOptionsComponent,
        GenerativeWidgetCommandLayoutComponent,
        SafeHtmlPipe,
        ChatSupportTickets,
        ChatImageMessageComponent,
        FilePreviewPopupComponent,
        ChatResourceCardsComponent
    ],
    providers: [
        ConfigurationService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ChatModule {
}
